import React, { useState, useEffect } from "react";
import axios from "axios";
import SliderCarouselSingleRedux from "../components/SliderCarouselSingleRedux";
import SliderCarousel from "../components/SliderCarouselsingle";
import FeatureBox from "../components/FeatureBox";
import CarouselCollectionRedux from "../components/CarouselCollectionRedux";
import ColumnNewRedux from "../components/ColumnNewRedux";
import ColumnNew from "../components/ColumnNew";
import AuthorListRedux from "../components/AuthorListRedux";
import Footer from "../components/footer";
import { createGlobalStyle } from "styled-components";
import Reveal from "react-awesome-reveal";
import { keyframes } from "@emotion/react";
import AuthorList from "../components/authorList";
import CarouselCollection from "../components/CarouselCollection";
import { useNavigate } from "react-router-dom";
import ListNFTForSaleList from "../components/NFTSaleLIst";
const domainpath = process.env.REACT_APP_API_DOMAIN_ENDPOINT;
const fadeInUp = keyframes`
  0% {
    opacity: 0;
    -webkit-transform: translateY(40px);
    transform: translateY(40px);
  }
  100% {
    opacity: 1;
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
`;
const inline = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;
const GlobalStyles = createGlobalStyle`
  header#myHeader.navbar .search #quick_search{
    background: rgba(255, 255, 255, .1);
  }
  header#myHeader .logo .d-block{
    display: none !important;
  }
  header#myHeader .logo .d-none{
    display: none !important;
  }
  header#myHeader .logo .d-3{
    display: block !important;
  }
  footer.footer-light .subfooter span img.d-1{
    display: none !important;
  }
  footer.footer-light .subfooter span img.d-3{
    display: inline-block !important;
  }
  .de_countdown{
    right: 10px;
  }
  .author_list_pp{
    margin-left:0;
  }
  footer.footer-light .subfooter{
    border-top: 1px solid rgba(255,255,255,.1);
  }
`;

const HomeThree = () => {
  const [stats, setStats] = useState({
    total_arts: 0,
    total_auction_count: 0,
    total_creators_count: 0,
    loading: true,
    error: null,
  });

  const navigate = useNavigate();
  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await axios.get(`${domainpath}/api/nft-stats`);
        setStats({
          ...response.data,
          loading: false,
          error: null,
        });
      } catch (err) {
        setStats((prev) => ({
          ...prev,
          loading: false,
          error: "Failed to fetch stats",
        }));
        console.error("Error fetching stats:", err);
      }
    };

    fetchStats();
  }, []);

  // Format number with "k" suffix if over 1000
  const formatNumber = (num) => {
    if (num >= 1000) {
      return (
        <>
          <span>{Math.floor(num / 1000)}</span>k
        </>
      );
    }
    return <span>{num}</span>;
  };
  return (
    <div>
      <GlobalStyles />
      <section className="jumbotron no-bg">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="spacer-single"></div>
              <Reveal
                className="onStep"
                keyframes={fadeInUp}
                delay={0}
                duration={600}
                triggerOnce
              >
                <h6 className="">
                  <span className="text-uppercase color">
                    ART COLLECT MARKET
                  </span>
                </h6>
              </Reveal>
              <div className="spacer-10"></div>
              <Reveal
                className="onStep"
                keyframes={fadeInUp}
                delay={300}
                duration={600}
                triggerOnce
              >
                <h1 className="">Create, sell or collect digital items.</h1>
              </Reveal>
              <Reveal
                className="onStep"
                keyframes={fadeInUp}
                delay={600}
                duration={600}
                triggerOnce
              >
                <p className=" lead">
                  Unit of data stored on a digital ledger, called a blockchain,
                  that certifies a digital asset to be unique and therefore not
                  interchangeable
                </p>
              </Reveal>
              <div className="spacer-10"></div>
              <Reveal
                className="onStep"
                keyframes={fadeInUp}
                delay={800}
                duration={900}
                triggerOnce
              >
                <span
                  onClick={() => window.open("/explore/all", "_self")}
                  className="btn-main lead"
                >
                  Explore
                </span>
                <div className="mb-sm-30"></div>
              </Reveal>
              <Reveal
                className="onStep "
                keyframes={inline}
                delay={900}
                duration={1200}
                triggerOnce
              >
                <div className="row">
                  <div className="spacer-single"></div>
                  <div className="row">
                    <div className="col-lg-4 col-md-6 col-sm-4 mb30">
                      <div className="de_count text-left">
                        <h3>
                          <span>{formatNumber(stats?.total_arts)}</span>
                        </h3>
                        <h5 className="id-color">Collectibles</h5>
                      </div>
                    </div>

                    <div className="col-lg-4 col-md-6 col-sm-4 mb30">
                      <div className="de_count text-left">
                        <h3>
                          <span>
                            {formatNumber(stats?.total_auction_count)}
                          </span>
                        </h3>
                        <h5 className="id-color">Auctions</h5>
                      </div>
                    </div>

                    <div className="col-lg-4 col-md-6 col-sm-4 mb30">
                      <div className="de_count text-left">
                        <h3>
                          <span>
                            {formatNumber(stats?.total_creators_count)}
                          </span>
                        </h3>
                        <h5 className="id-color">NFT Artist</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </Reveal>
              <div className="spacer-double"></div>
            </div>
            {/* <SliderCarouselSingleRedux/> */}
            <div className="col-lg-6 px-0 slidertop">
              <SliderCarousel />
            </div>
          </div>
        </div>
      </section>

      <section className="container no-top">
        <div className="container px-0">
          <FeatureBox />
        </div>
      </section>

      <section className="container" id="arts">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2 className="text-center">New Items</h2>
              <div className="small-border"></div>
            </div>
          </div>
          {/* <ColumnNewRedux /> */}
          <ColumnNew />
        </div>
      </section>

      {/* <ListNFTForSaleList /> */}

      <section className="container no-top">
        <div className="row">
          <div className="col-lg-12">
            <h2 className="text-center">Hot Collections</h2>
            <div className="small-border"></div>
          </div>
        </div>
        <div className="container no-top">
          <div className="row">
            <div className="col-lg-12 px-0">
              {/* <CarouselCollectionRedux /> */}
              <CarouselCollection />
            </div>
          </div>
        </div>
      </section>

      <section className="container no-top">
        <div className="row">
          <div className="col-lg-12">
            <h2 className="text-center">Top Seller</h2>
            <div className="small-border"></div>
          </div>
          <div className="col-lg-12">
            {/* <AuthorListRedux /> */}
            <AuthorList />
          </div>
        </div>
      </section>

      <section className="container no-top">
        <div className="row">
          <div className="col-lg-12 text-center">
            <h2 className="text-center">DROP</h2>
            <div className="small-border"></div>
          </div>
        </div>
        <div className="container px-0">
          <div className="row">
            <div
              className="col-lg-3 col-sm-4 col-6 mb30"
              onClick={() => navigate("/create")}
            >
              <span className="box-url">
                <i className="fa fa-picture-o"></i>
                <h4>Image</h4>
              </span>
            </div>
            <div
              className="col-lg-3 col-sm-4 col-6 mb30"
              onClick={() => navigate("/create")}
            >
              <span className="box-url">
                <i className="fa fa-video-camera"></i>
                <h4>Video</h4>
              </span>
            </div>

            <div
              className="col-lg-3 col-sm-4 col-6 mb30"
              onClick={() => navigate("/create")}
            >
              <span className="box-url">
                <i className="fa fa-volume-up"></i>
                <h4>Audio</h4>
              </span>
            </div>

            <div
              className="col-lg-3 col-sm-4 col-6 mb30"
              onClick={() => navigate("/create")}
            >
              <span className="box-url">
                {/* <i className="fa fa-globe"></i> */}
                <div
                  style={{
                    height: " 50px",
                    width: "50px",
                    margin: "0 auto",
                    marginBottom: "6px",
                  }}
                >
                  <img
                    width="100%"
                    height="auto"
                    alt="giffile"
                    src="./img/giffile.png"
                  />
                </div>
                <h4>gif</h4>
              </span>
            </div>

            {/* <div className="col-lg-2 col-sm-4 col-6 mb30">
            <span className="box-url">
              <i className="fa fa-vcard"></i>
              <h4>Trading Cards</h4>
            </span>
          </div>

          <div className="col-lg-2 col-sm-4 col-6 mb30">
            <span className="box-url">
              <i className="fa fa-th"></i>
              <h4>Collectibles</h4>
            </span>
          </div> */}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};
export default HomeThree;
